import { useMemo } from 'react';
import { getDueDatePresets, getFormattedOptions } from '../utils/RelativeDatePresets';
import I18n from 'I18n';
export function useDateTimePresetOptions({
  presets = getDueDatePresets(),
  skip = false
}) {
  const startOfToday = I18n.moment.userTz().startOf('day').valueOf();
  return useMemo(() => {
    if (skip) {
      return [];
    }
    return getFormattedOptions(presets);
    // We want to update our presets if we're re-rendering on a new day—even
    // though the default timestamp isn't passed into anything.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startOfToday, skip, presets]);
}